console.log("imtk_common");

var checkMobile = function () {
  var a = navigator.userAgent||navigator.vendor||window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4));
};

//iphone swap image issue
$(function(){
  if ($(window).width() <= 798) {
    $(".swap-true .secondary").remove();
    $(".swap-true").removeClass("swap-true");
  }
});

//filter menu
$(function(){
  if ($(window).width() <= 798) {
    if($(".sidebar__collection-filter").length>0){
      $filterContent = $(".sidebar__collection-filter").parent().parent().parent();
      $filterContent.css("width","280px");
      $filterContent.css("margin-left","20px");

      $filterDiv = $('<div class="imtk-filter-container"></div>');
      $filterDiv.append($filterContent);
      $('body').append($filterDiv);

      $overlay = $('<div class="imtk-filter-overlay"></div>');
      $('body').append($overlay);

      $resetBtn = $('<div class="imtk-filter-reset-btn">Reset Filters</div>');
      $closeBtn = $('<div class="imtk-filter-close-btn">Close<div class="float-right x">X</div></div>');
      $btnsContainer = $('<div class="imtk-filter-btn-container"></div>');
      $btnsContainer.append($resetBtn);
      $btnsContainer.append($closeBtn);

      $filterBtn = $('<div class="imtk-filter-filter-btn">Filter <span id="imtk_filter_count" style="color:#aaa;"></span><img src="//www.specscollective.com/cdn/shop/t/300/assets/filter-icon_small.png?v=144914"/></div>');
      $view1Btn = $('<div id="imtk_view_btn_1" onclick="imtkChangeView(true)" class="imtk-filter-view-1-btn">.<div style="height:44px;width:18px;position:absolute;top:0;left:0;background:#000;"></div><div style="height:44px;width:18px;position:absolute;top:0;right:0;background:#000;"></div></div>');
      $view2Btn = $('<div id="imtk_view_btn_2" onclick="imtkChangeView(false)" class="imtk-filter-view-2-btn">.</div>');
      $BtnDiv = $('<div class="imtk-filter-btn-div"></div>');
      $BtnDiv.append($filterBtn);
      $BtnDiv.append($view1Btn);
      $BtnDiv.append($view2Btn);
      $BtnDiv.insertBefore(".product-list.collection-matrix");
      //$(".collection_description").append($BtnDiv);

      function closeFilter(e){
        $filterDiv.hide();
        $overlay.fadeOut("1000");
        $('html').css('overflow-y',"auto");
      }

      function resetFilter(e){
        var redirectUrl = /\/collections\/[^\/]*/.exec(window.location.href)[0];
//         if(redirectUrl !=window.location.href){
          $('[data-option-filter] input').attr('checked', false);
          $('[data-option-filter] input').first().trigger('change');
          closeFilter();
//         }
      }
      $overlay.on("click",closeFilter);

      $filterBtn.on("click", function(e){
        $filterContent.prepend($btnsContainer);
        $filterDiv.show();
        $overlay.fadeIn("1000");
        $('html').css('overflow-y',"hidden");
        $(".clear-active-filter").css("top","19px");

        $(".clear-active-filter").on("click", closeFilter);
        $filterContent.find('li').find('label').on("click", closeFilter);
        $closeBtn.on("click",closeFilter);
        $resetBtn.on("click",resetFilter);
        
//         if(!/\/collections\/[^\/]*\/./.test(window.location.href)){
//           $resetBtn.addClass("imtk_inactive");
//         } 
//         else {
//           $resetBtn.removeClass("imtk_inactive");
//         }
      });
      imtkUpdateFilter();
    }
  }
});

function imtkUpdateFilter(data){
  var products_count = data?$(data).filter('#imtk_data').attr('products_count'):$('#imtk_data').attr('products_count');
  console.log('products_count:', products_count);

  var count = parseInt(products_count);
  var text = '';

  if(count == 1){
    text = '(1 item)'; 
  } 
  else if(count > 1){
    text = '('+  products_count +' items)';
  }

  $('#imtk_filter_count').html(text);
}
function imtkChangeView(wider){
  if(wider){
    $('.product-list>div').addClass("one-third column medium-down--one-half small-down--one-half");
    $('#imtk_view_btn_1').find('div').css('background','#000');
    $('#imtk_view_btn_2').css('background','#aaa');
    $('.imtk-preview-carousel').flickity('resize');
  }
  else {
    $('.product-list>div').removeClass("one-third column medium-down--one-half small-down--one-half");
    $('#imtk_view_btn_1').find('div').css('background','#aaa');
    $('#imtk_view_btn_2').css('background','#000');
    $('.imtk-preview-carousel').flickity('resize');
  }
}

//sliding side menu
$(function(){
  var sideMenuOpened = false;

  if ($(window).width() <= 798) {
    $('.mobile-mega-menu[data-mobile-dropdown="shop-optical"], .mobile-mega-menu[data-mobile-dropdown="shop-sun"]').find("a img").hide();
  }
  else {
    $('.mega-menu[data-dropdown="shop-optical"], .mega-menu[data-dropdown="shop-sun"]').find("a p").hide();
  }
  if ($(window).width() <= 798) {
    $forcedCss=$('<style>html, body{overflow-x: hidden;width: 100%;}.dropdown_container[data-dropdown="menu"] {display:block !important;width:0px;}</style>');
    $("body").append($forcedCss);

    $target = $(".imtk-body-container");
    //$("html").css("width",$("html").width()+"px");
    $(".dropdown_container[data-dropdown='menu'] .dropdown").css("width","300px");
    $target.css("width","100%");
    $target.css("transition","margin-left 1s");
    $(".dropdown_container").css("width","0");
    $(".dropdown_container").css("overflow","hidden");
    $(".dropdown_container[data-dropdown='menu']").css("transition","width 1s");
    $(".dropdown_container[data-dropdown='menu']").css("display","block !important");
    $(".dropdown_container[data-dropdown='menu']").css("overflow","hidden !important");
    $(".dropdown_container[data-dropdown='menu']").css("background","white");
    $(".dropdown_container[data-dropdown='menu']").css("z-index","100");
    $(".dropdown_container[data-dropdown='menu']").css("position","absolute");

    function closeMenu(){
      sideMenuOpened = false;
      $target.css("margin-left","0px");
      $("html, body").css("overflow-y","auto");
      $(".dropdown_container[data-dropdown='menu']").css("width","0px");
      $overlay.fadeOut("1000");
      $overlay.css("width", "100%");
    }
    $(document).click(function(event) {
      if(sideMenuOpened&&!$(event.target).closest(".dropdown_container[data-dropdown='menu']").length) {
        closeMenu();
      }
    });

    var $overlay = $('<div style="width: 100%;position: absolute;top: 55px;transition: width 1s;background-color: rgba(0,0,0,0.2);display: none;"></div>');
    $target.append($overlay);

    $(".dropdown_link[data-dropdown-rel='menu']").on('click', function(e) {
      bodyHeight = $("body").height()-40;
      $overlay.css("height",bodyHeight+"px");
      $(".dropdown_container[data-dropdown='menu']").css("height",bodyHeight+"px");
      if(!sideMenuOpened){
        sideMenuOpened = true;
        $target.css("margin-left","320px");
        $('html, body').css('overflow-y',"auto");
        $(".dropdown_container[data-dropdown='menu']").css("width","320px");
        $overlay.fadeIn("1000");
        $overlay.css("width", "calc(100% - 320px)");
      }
      else {
        closeMenu();
      }
    })
  } 
});

//remove lens options in the cart on the site lending
// ============================================================================
// SPECS FIX (10 AUG 2026) — THE STRIP IS RETIRED.
// The old code here deleted every cart line item with product_type
// "OPTIONS_HIDDEN_PRODUCT" on every page load, and imtk_cart.js
// checkoutAndSubmit() re-added them from the frame's _variantIds property at
// checkout click. Consequence: the live cart was frame-only at almost every
// moment, so Shopify abandoned-checkout recovery links resumed a frame-only
// session — customers paid frame-only prices while the frame's properties
// promised prescription lenses.
// Lens option line items now stay in the cart permanently. Display
// consolidation, orphan cleanup, and quantity sync live in
// snippets/specs-cart-integrity.liquid. checkoutAndSubmit() remains as an
// idempotent quantity re-sync at checkout click.
// ROLLBACK: restore this block from theme version history (or the previous
// theme export) — no other file depends on the strip being gone.
// ============================================================================
$(function(){
  var cart;
  if(window.IMTK && window.IMTK.shopify && window.IMTK.shopify.cart){
    cart = window.IMTK.shopify.cart;
  }

  if(cart){
    var needToHidePaypalBtn = false;

    cart.items.forEach(function(item){
      if(item.properties) needToHidePaypalBtn = true;
    });

    $("#cart_form").removeClass("imtk_hidden");
    $(".cart_count, .total_price_mini_cart").css("cssText", "display: inline-block !important;");
    $(".js-cart_items").css("cssText", "display: block !important;");
    if(needToHidePaypalBtn) $(".additional-checkout-buttons .paypalLight").hide();
  }

});



//collections option overlay on thumbnail preview

//

//

  imtkInitOptionsPreview = function(){
  console.log("option preview");
  var isMobile = checkMobile();
  if(isMobile){
    imtkInitOptionsPreviewCarousel();
    return;
  }

  var $targets = $("[data-imtk_options_preview]");
  $targets.each(function(index, target){
    var $target = $(target);

    if(!$target.data("imtk-options-preview-eabled")){
      $target.data("imtk-options-preview-eabled", true);

      var $targetContainer = $(this).closest(".product-wrap");
      $targetContainer.find(".swap-true").removeClass('swap-true');
      $targetContainer.find("img.secondary").hide();

      var variants = $(this).data("imtk_options_preview");
      if(!Array.isArray(variants)) return;
      variants = variants.reduce(function(accumulator, current){
        var currentArray = (Array.isArray(accumulator))?accumulator:[accumulator];
        var filtered = currentArray.filter(function(elem){
          return elem.option1 == current.option1
        });
        if(filtered.length == 0) currentArray.push(current);
        return currentArray;
      });


      if(variants.length>0){
        var targetLinkUrl = $targetContainer.find("a").attr("href");
      	targetLinkUrl = targetLinkUrl+ (/\?/.test(targetLinkUrl)?"&":"?");

        var $targetImage = $targetContainer.find(".image__container img");
        $targetImage.attr("src", $target.data("src"));
        $targetImage.attr("srcset", $target.data("src"));

        var $optionsPreviewThumbnailOverlay = $('<a href="'+targetLinkUrl+'" class="imtk-options-preview-thumnail-ovelay"></a>'); 
        $optionsPreviewThumbnailOverlay.css("height","100%");

        var $targetDescription = $targetContainer.find(".product-info__caption");

        var $optionsPreviewInnerBottom = $('<a href="'+targetLinkUrl+'" class="imtk-options-preview-inner-bottom"></a>'); 
        $optionsPreviewInnerBottom.html($targetDescription.html());

        var $optionsPreviewInnerImageContainer = $('<div class="imtk-options-preview-inner-image-container"></div>'); 

        variants.forEach(function(variant){
          var imageUrl = variant.featured_image.src;
          var id = variant.id;
          var $optionsPreviewInnerImage = $('<img class="imtk-options-preview-inner-image">'); 
          $optionsPreviewInnerImage.attr("src", imageUrl);
          var $optionsPreviewInnerImageA = $('<a title="'+variant.option1+'"></a>');
          $optionsPreviewInnerImageA.attr("href", targetLinkUrl);
          $optionsPreviewInnerImageA.append($optionsPreviewInnerImage);
          $optionsPreviewInnerImageContainer.append($optionsPreviewInnerImageA);
          $optionsPreviewInnerImage.on("mouseover",function(){
            var imagePath = $(this).attr("src");
            var $targetImage = $targetContainer.find(".image__container img");
            var url = targetLinkUrl+"variant="+id;
            $targetImage.attr("src", imagePath);
            $targetImage.attr("srcset", imagePath);
            $targetContainer.find(".imtk-options-preview-thumnail-ovelay").attr("href", url);
            $targetContainer.find(".imtk-options-preview-inner-bottom").attr("href", url);
            $(this).parent().attr("href", url);
          });
        });


        var $optionsPreviewInnerTop = $('<div class="imtk-options-preview-inner-top"></div>'); 
        $optionsPreviewInnerTop.append($optionsPreviewInnerImageContainer);

        var $optionsPreviewInner = $('<div class="imtk-options-preview-inner"></div>');
        $optionsPreviewInner.append($optionsPreviewInnerTop);
        $optionsPreviewInner.append($optionsPreviewInnerBottom);

        var $optionsPreviewContainer = $('<div class="imtk-options-preview-container"></div>');
        $optionsPreviewContainer.append($optionsPreviewThumbnailOverlay);
        $optionsPreviewContainer.append($optionsPreviewInner);
        $optionsPreviewContainer.hide();

        $targetContainer.append($optionsPreviewContainer);


        var imageContainerWidth = 81*variants.length;
        if(imageContainerWidth>$targetContainer.width()){
          $optionsPreviewInnerImageContainer.css("width",imageContainerWidth+45+"px")
          var $optionsPreviewInnerTopLeft = $('<div class="imtk-options-preview-inner-top-left"> < </div>'); 
          var $optionsPreviewInnerTopRight = $('<div class="imtk-options-preview-inner-top-right"> > </div>'); 
          $optionsPreviewInnerTop.append($optionsPreviewInnerTopLeft);
          $optionsPreviewInnerTop.append($optionsPreviewInnerTopRight);
          $optionsPreviewInnerImageContainer.addClass("imtk-options-preview-inner-image-container-with-arrow");

          var arrowGap = 81;

          $optionsPreviewInnerTopLeft.on("click",function(){
            var $imageContainer = $(this).parent().find(".imtk-options-preview-inner-image-container");
            var imageContainerLeft = parseInt($imageContainer.css("left"));

            var nextLeft = imageContainerLeft+arrowGap;
            var limit = 0;

            if(nextLeft<0){
              $imageContainer.css("left", nextLeft+"px");
            } 
            else{
              $imageContainer.css("left", 0);
            }
          });

          $optionsPreviewInnerTopRight.on("click",function(){
            var $imageContainer = $(this).parent().find(".imtk-options-preview-inner-image-container");
            var imageContainerLeft = parseInt($imageContainer.css("left"));
            var imageContainerWidth = parseInt($imageContainer.css("width"));
            var previewContainerWidth = parseInt($optionsPreviewContainer.css("width"));

            var nextLeft = imageContainerLeft-arrowGap;
            var limit = previewContainerWidth-imageContainerWidth;
            if(nextLeft>limit){
              $imageContainer.css("left", nextLeft+"px");
            } 
            else{
              $imageContainer.css("left", limit+"px");
            }
          });
        }

        $targetContainer.mouseover(function(){
          var firstImage = $optionsPreviewInnerImageContainer.find("img").eq(0);
          //console.log("mouseover");
          $(this).find(".imtk-options-preview-container").show();

        });//end $targetContainer.mouseover(function(){

        $targetContainer.mouseleave(function(){
          //console.log("mouseleave");
          $(this).find(".imtk-options-preview-container").hide();

        });//end $targetContainer.mouseleave(function(){

      } //if(variants.length>0){
    }//end if(!$target.data("optionPreviewEnabled")){
  });//end $targets.each(function(index, target){
};//end imtkInitOptionsPreview = function(){

$(function(){
  imtkInitOptionsPreview();
});

//   //custum menu item
//   $(function(){
//     function desktopMenu(){
//       var targetColumn = $('header [data-dropdown="shop-sun"] .dropdown_column').eq(0);
//       var newItem = targetColumn.find('.mega-menu__image-caption-link').eq(0).clone();
//       if(newItem.length ===0) return setTimeout(desktopMenu,200);
//       newItem.find('a').attr('href','/collections/bob-sdrunk-sunglasses');
//       newItem.find('img').attr('src','https://cdn.shopify.com/s/files/1/1140/7330/files/bob-sdrunk-logo_copy_500x.png').removeAttr('data-src').removeAttr('data-sizes').removeAttr('data-srcset').removeAttr('srcset');
//       targetColumn.append(newItem);
//     }

//     function mobileMenu(){
//       var targetColumn = $('header [data-mobile-dropdown="shop-sun"] div').eq(0);
//       var newItem = targetColumn.find('.mobile-mega-menu_block').not('.mega-menu__richtext').eq(0).clone();
//       if(newItem.length ===0) return setTimeout(mobileMenu,200);
//       newItem.find('a').attr('href','/collections/bob-sdrunk-sunglasses');
//       newItem.find('img').remove();
//       newItem.find('p').text('BOB SDRUNK');
//       targetColumn.append(newItem);
//     }
//     setTimeout(desktopMenu,200);
//     setTimeout(mobileMenu,200);
//   });

//resize carousel
$(function(){
  var scale = 1.5;

  function resizeCarousel(){
    $(".featured-collection__products").each(function(index,item,array){
      //console.log(item);
      var $flickityContainer = $(item);
      var $flickity = $flickityContainer.find(".flickity-viewport");

      if($flickity.length > 0){
        console.log("resizing: ", $flickity.data("resizing"));
        if($flickity.data("resizing") != "processing"){
          $flickity.data("resizing", "processing");
          setTimeout(function(){
            var originalHeight = parseInt($flickity[0].style.height);
            var newHeight = originalHeight*scale;
            var heightDiff = (newHeight - originalHeight);

            if(index === 0){
              console.log("originalHeight: ", originalHeight);
              console.log("newHeight: ", newHeight);
            }

            $flickity.css("min-height",newHeight+"px");
            $flickity.css("transform","scale("+scale+") translate(0px,"+heightDiff/2+"px)");

            $flickity.data("resizing", "idle");
          },500);
        }
      }
    });
  }

  $(function(){
    if(checkMobile()) resizeCarousel();
  });

  $(window).resize(function(){
    if(checkMobile()) resizeCarousel();
  });
});

imtkInitOptionsPreviewCarousel = function(){
  console.log("option preview carousel");

  var $targets = $("[data-imtk_options_preview]");
  $targets.each(function(index, target){
    var $target = $(target);

    if(!$target.data("imtk-options-preview-eabled")){
      $target.data("imtk-options-preview-eabled", true);

      var $targetContainer = $(this).closest("a");
      //$targetContainer.css('position','relative');

      var variants = $(this).data("imtk_options_preview");
      if(!Array.isArray(variants)) return;
      variants = variants.reduce(function(accumulator, current){
        var currentArray = (Array.isArray(accumulator))?accumulator:[accumulator];
        var filtered = currentArray.filter(function(elem){
          return elem.option1 == current.option1
        });
        if(filtered.length == 0) currentArray.push(current);
        return currentArray;
      });
      
      variants = variants.length>0?variants:[variants];

      var targetLinkUrl = $targetContainer.attr("href");
      targetLinkUrl = targetLinkUrl+ (/\?/.test(targetLinkUrl)?"&":"?");
      $target.closest("a").removeAttr("href");

      var $previewCarousel=$('<div class="imtk-preview-carousel"></div>');

      variants.forEach(function(variant){
        var imageUrl = variant.featured_image.src;
        var url = targetLinkUrl+"variant="+variant.id;

        var $previewCarouselCell=$('<div class="carousel-cell"> <a href="'+url+'"> <img class="carousel-cell-image" src="'+imageUrl+'"/> </a> </div>');
      	$previewCarousel.append($previewCarouselCell);
      });

      $targetContainer.html('');
      $targetContainer.append($previewCarousel);
      setTimeout(function(){
        $previewCarousel.flickity({
          prevNextButtons: false,
          wrapAround: true,
          cellAlign: 'left',
          contain: true,
        });
      },0);
    }
  });
}